$(document).ready(function () {
  $(".home-product-section .custom-product-slider:not(.swiper-applied):not(.slick-initialized)").slick({
    slidesToShow: 2,
    loop: true,
    infinite: true,
    centerMode: true,
    centerPadding: "50px",
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "50px",
        },
      },
    ],
  });
  
  $(".product-review-slider-sec .product-review-slider:not(.swiper-applied):not(.slick-initialized)").slick({
     slidesToShow: 3,
     loop:false,
     infinite:false,
     centerMode: false,
     centerPadding: '50px',
     slidesToScroll: 1,
     autoplay: false,
     autoplaySpeed: 2000,
     arrows:true,
     dots:false,
      responsive: [
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '50px',
        },
      },
        {
        breakpoint: 575,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
          centerPadding: '50px',
          infinite:true
        },
      },
    ],
  });


  
  $(".announcement-bar-layout3").slick({
     slidesToShow: 1,
     infinite:true,
     slidesToScroll: 1,
     autoplay:true,
     autoplaySpeed: 2000,
     arrows:true,
     dots:false,
    });
});


$(document).ready(function() {
 
   $('.mega-menu').on('click', function() {
        $('.section-header').toggleClass('header-mega-menu-open');
    });

   
  
  function initializeSlick() {
        if ($(window).width() <= 749) {
            if (!$(".announcement-bar-layout4").hasClass('slick-initialized')) {
                $(".announcement-bar-layout4").slick({
                    slidesToShow: 1,
                    infinite: true,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    arrows: true,
                    dots: false,
                });
            }
        } else {
            if ($(".announcement-bar-layout4").hasClass('slick-initialized')) {
                $(".announcement-bar-layout4").slick('unslick'); // Destroy the slider
            }
        }
    }

    // Initialize on page load
    initializeSlick();

    // Reinitialize on window resize
    $(window).resize(function() {
        initializeSlick();
    });
  



$(".popup-btn").click(function() {
  // Show the overlay and fade it in
  $(".overlay").fadeIn(500);
  
  // Show the popup and slide it in from the right
  $(".popup").css('display', 'block').animate({
    right: '50px'
  }, 500);
});

// Close the popup when the close button is clicked
$(".popup-close").click(function() {
  closePopup();
});

// Close the popup when the overlay is clicked
$(".overlay").click(function() {
  closePopup();
});

// Function to handle closing the popup
function closePopup() {
  // Slide the popup out to the right
  $(".popup").animate({
    right: '-600px'  // Slide out off-screen to the right
  }, 500, function() {
    $(this).css('display', 'none');
  });
  
  // Fade out the overlay
  $(".overlay").fadeOut(500);
}

   
});






document.querySelectorAll('.footer-block--menu .footer-block__heading.footer-menu-title').forEach(header => {
    header.addEventListener('click', () => {
        if (window.innerWidth < 749) { // Check if the viewport width is less than 749px
            const content = header.nextElementSibling; // Get the associated content

            // Close all accordion contents
            document.querySelectorAll('.footer-block__details-content').forEach(item => {
                if (item !== content) {
                    item.style.display = 'none'; // Close other sections
                    item.previousElementSibling.classList.remove('open'); // Reset open class
                }
            });

            // Toggle the clicked content
            if (content.style.display === "block") {
                content.style.display = "none"; // Close
                header.classList.remove('open'); // Reset open class
            } else {
                content.style.display = "block"; // Open
                header.classList.add('open'); // Add open class
            }
        }
    });
});


$(document).ready(function() {
    function moveToMobile() {
        if ($(window).width() <= 749) {
            // Move elements if they are not already moved
            if (!$(".footer-logo").parent().is(".mobile-logo-social")) {
                $(".footer-logo").appendTo(".mobile-logo-social");
                
            }
            if (!$(".footer-social-icons").parent().is(".mobile-logo-social")) {
                $(".footer-social-icons").appendTo(".mobile-logo-social");
            }
          if (!$(".footer-block__newsletter").parent().is(".mobile-newsletter")) {
                $(".footer-block__newsletter").appendTo(".mobile-newsletter");
          }
          if (!$(".home-mobile-btn").parent().is(".mobile-shop-btns")) {
                $(".home-mobile-btn").appendTo(".mobile-shop-btns");
          }
          if (!$(".home-mobile-btn1").parent().is(".mobile-shop-btns1")) {
                $(".home-mobile-btn1").appendTo(".mobile-shop-btns1");
          }
          if (!$(".mobile-product-shop-btn").parent().is(".prodcut-reivew-shop-btn")) {
                $(".mobile-product-shop-btn").appendTo(".prodcut-reivew-shop-btn");
          }
           if (!$(".mobile-product-shop-btn").parent().is(".mobile-product-shop-btn-div")) {
                $(".mobile-product-shop-btn").appendTo(".mobile-product-shop-btn-div");
          }
          
         
        } else {
            // Optional: Move them back to original position if needed
            // Uncomment and adjust if you want to revert on larger screens
            // $(".footer-logo").appendTo(".original-footer-container");
            // $(".footer-social-icons").appendTo(".original-footer-container");
        }
    }

    // Initial check
    moveToMobile();

    // Check on resize
    $(window).resize(function() {
        moveToMobile();
    });
});


/******Case Study Pagination******/
const items = document.querySelectorAll('.case_study_item');
const itemsPerPage = 6; // Number of items to display per page
const totalPages = Math.ceil(items.length / itemsPerPage); // Calculate total pages
let currentPage = 1; // Current page initialized to 1

// Get the necessary pagination elements
const prevButton = document.getElementById('prev');
const nextButton = document.getElementById('next');
const pageButtonsContainer = document.getElementById('page-buttons');
const listContainer = document.querySelector('.case-study-list-sec'); // The section to scroll to

// Function to show the current page
function showPage(page) {
    items.forEach((item, index) => {
        // Display items based on the current page
        item.style.display = (index >= (page - 1) * itemsPerPage && index < page * itemsPerPage) ? 'block' : 'none';
    });
    
    // Disable Prev and Next buttons appropriately
    if(prevButton){
      prevButton.disabled = (page === 1);
    }
    if(nextButton){
      nextButton.disabled = (page === totalPages);  
    }
    
    // Clear existing buttons
    if(pageButtonsContainer){
      pageButtonsContainer.innerHTML = ''; 
    }

    // Create buttons for pagination
    for (let i = 1; i <= totalPages; i++) {
        const button = document.createElement('button');
        button.textContent = i;
        button.className = 'page-button' + (i === page ? ' active' : '');
        button.addEventListener('click', () => {
            currentPage = i;
            showPage(currentPage);
            scrollToTop(); // Scroll to the top of the section
        });
        if(pageButtonsContainer){
          pageButtonsContainer.appendChild(button);
        }
    }
}

// Scroll to the top of the item list container
function scrollToTop() {
    listContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Event listeners for Prev and Next buttons
if(prevButton){
  prevButton.addEventListener('click', () => {
      if (currentPage > 1) {
          currentPage--;
          showPage(currentPage);
          scrollToTop(); // Scroll to the top when changing pages
      }
  });
}

if(nextButton){
  nextButton.addEventListener('click', () => {
      if (currentPage < totalPages) {
          currentPage++;
          showPage(currentPage);
          scrollToTop(); // Scroll to the top when changing pages
      }
  });
}

// Function to initialize pagination
function initializePagination() {
    // Show the first page by default
    showPage(currentPage);
}

// Call the initialize function on load
initializePagination();

// Optional: Add a listener to handle window resizing
window.addEventListener('resize', initializePagination);


// Load More Button Functionality

document.addEventListener("DOMContentLoaded", function() {
    const itemsToShow = 6; // Number of items to show on each click
    const listItems = document.querySelectorAll('.case_study_item'); // Get all items
    const totalItems = listItems.length; // Total items
    let visibleItems = 6; // Initial visible items
    const loadMoreButton = document.getElementById('load-more');

    // Initially hide all items after the first 6
   if(listItems.length > 0){
    for (let i = 6; i < totalItems; i++) {
        listItems[i].style.display = 'none';
    }

    // Show the initial items
    for (let i = 0; i < visibleItems; i++) {
        listItems[i].style.display = 'block';
    } 
   }
    

    // Load more functionality
    if(loadMoreButton){
      loadMoreButton.addEventListener('click', function() {
        // Calculate how many items to show next
        const nextItems = visibleItems + itemsToShow;
      
        // Show the next set of items
        for (let i = visibleItems; i < nextItems && i < totalItems; i++) {
            listItems[i].style.display = 'block';
        }
      
        // Update the visible items count
        visibleItems = nextItems;
      
        // If all items are shown, hide the load more button
        if (visibleItems >= totalItems) {
            loadMoreButton.style.display = 'none';
        }
      });
    }
    

    // Check screen width and disable functionality above 749px
    function checkScreenSize() {
        if (window.innerWidth >= 749) {
            if(loadMoreButton){
              loadMoreButton.style.display = 'none'; // Hide button if above 749px  
            }
            // Reset visible items and enable pagination
            visibleItems = 0; // Reset for desktop
            showPage(1); // Show first page
        } else {
            if(loadMoreButton){
              loadMoreButton.style.display = 'block'; // Show button if below 749px
            }
            // Reset visible items to initial state
            visibleItems = 6;
            for (let i = 0; i < totalItems; i++) {
                if (i < visibleItems) {
                    listItems[i].style.display = 'block'; // Show initial items
                } else {
                    listItems[i].style.display = 'none'; // Hide others
                }
            }
        }
    }

    // Check screen size on load and on resize
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
});


/******Case study content show Mobile****/
class Box {
    constructor(element) {
        this.box = element;
        this.content = this.box.querySelector('.mobile-case-study-content');
        this.closeBtn = this.content.querySelector('.close-case-study-content');
        this.image = this.box.querySelector('.case-study-img-content'); // Get the image

        // Bind the methods
        this.toggleContent = this.toggleContent.bind(this);
        this.closeContent = this.closeContent.bind(this);

        // Initialize functionality based on screen size
        this.init();

        // Optional: Add a resize event listener to handle changes
        window.addEventListener('resize', () => this.init());
    }

    init() {
        const viewportWidth = window.innerWidth;

        // Add event listeners if below 749px
        if (viewportWidth < 749) {
            this.image.addEventListener('click', this.toggleContent); // Listen for clicks on the image
            this.closeBtn.addEventListener('click', this.closeContent); // Listen for clicks on the close button
        } else {
            // Remove event listeners if above 749px
            this.image.removeEventListener('click', this.toggleContent);
            this.closeBtn.removeEventListener('click', this.closeContent);
            this.closeContent(); // Ensure content is closed when resizing
        }
    }

    toggleContent(event) {
        event.stopPropagation(); // Prevent event from bubbling up to the box
        const isOpen = this.box.classList.toggle('active');
        if (isOpen) {
            console.log('Content opened in box:', this.box);
        } else {
            console.log('Content closed in box:', this.box);
        }
    }

    closeContent(event) {
        if (event) event.stopPropagation(); // Prevents the click event from bubbling up
        this.box.classList.remove('active'); // Removes the 'active' class to hide the content
        console.log('Content closed in box:', this.box);
    }
}

// Instantiate the Box class for each box element
document.querySelectorAll('.case_study_item').forEach(boxElement => {
    new Box(boxElement);
});


document.addEventListener("DOMContentLoaded", (event) => {
  if( document.querySelector('.show_image_review--true') ){
    review_slider_image();
  }
});

/* judge.me revire slider image */
function review_slider_image(){
  const review_slider = document.querySelectorAll('.show_image_review--true .shopify-block[id*=judge_me_reviews_featured]');
  if( review_slider.length > 0 ){
    document.querySelector('body').removeAttribute('review_slider_image');    
    setTimeout(() => {
      review_slider.forEach(function(rs){
        rs.closest('.shopify-section').classList.add('judge_me_reviews_featured--section');
        rs.querySelectorAll('.jdgm-carousel-item__product-image').forEach(function(imgEle){
          let client_width = imgEle.clientWidth + 100;
          client_width = client_width+'x'+client_width;
          let imgEle_src = imgEle.src;
          let imgEle_data_src = imgEle.dataset.src;
          imgEle_data_src = imgEle_data_src.indexOf('_140x') > -1 ? imgEle_data_src.replace('_140x140','_'+client_width) : imgEle_data_src.replace('_70x70','_'+client_width);
          imgEle_src = imgEle_src.indexOf('_140x') > -1 ? imgEle_src.replace('_140x140','_'+client_width) : imgEle_src.replace('_70x70','_'+client_width);
          imgEle.dataset.src = imgEle_data_src;
          imgEle.dataset.srcRetina = imgEle_data_src;
          imgEle.src = imgEle_src;
        });
      });            
    }, 350);
  }else{
    if( document.querySelector('body[review_slider_image]') == null ){
      document.querySelector('body').setAttribute('review_slider_image',0);
    }
    let get_count = Number(document.querySelector('body').getAttribute('review_slider_image'));
    if( get_count < 10 ){
      document.querySelector('body').setAttribute('review_slider_image', (get_count+1));            
      setTimeout(() => {
        review_slider_image();   
      }, 1950);
    }
  }
}
/* judge.me revire slider image */

/**/
document.addEventListener('galleryReady:covetPics', function(e) {
    /*// prepare CSS styles to inject*/
    var stylesPopup = document.createElement( 'style' );
    stylesPopup.innerHTML = `
      @media screen and (max-width: 749px) {
      covet-pics-gallery-slider section.gallery .swiper-pagination.dots { display: none; }
      covet-pics-gallery-slider.pagination-bottom { padding-bottom: 0; }
      covet-pics-gallery-slider .swiper-pagination { display: none; }
      }
    `;
    /*// get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)*/
    var popup = document.querySelector("covet-pics-widget");
    popup.closest('.shopify-section').classList.add('covet-pics-widget--section');
    
    /*// now inject CSS code into shadow DOM*/
    popup.shadowRoot.appendChild(stylesPopup);    
    
    if( window.innerWidth < 750 ){
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.spaceBetween = 10;
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.slidesPerView = 1.48;
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.centeredSlides = true;
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(1);
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.update();
    }
});
/**/